export enum MemberFeeTypeEnum {
  Unknown = 0,
  AllMembersSameFee = 1,
  HeadAndFamily = 2,
  FamilyLadder = 3,
  HouseholdSameFee = 4,
  ProfileBasedFee = 5,
}
